import {
  AlignmentType,
  Document,
  Packer,
  PageOrientation,
  Paragraph,
  ShadingType,
  Table,
  TableCell,
  TableLayoutType,
  TableRow,
  TextRun,
  VerticalAlign,
  WidthType,
} from 'docx';

import { saveAs } from 'file-saver';

const createTitle = (text) => {
  return new Paragraph({
    children: [
      new TextRun({
        text: `* ${text}`,
        bold: true,
        size: 28, // 제목 크기 설정
      }),
    ],
    alignment: AlignmentType.LEFT,
  });
};

const createPersonalInfoTable = (personalInfo) => {
  return new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '성명',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 15, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.name)],
            width: { size: 20, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '생년월일',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 15, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.formattedBirthDate)],
            verticalAlign: VerticalAlign.CENTER,
            width: { size: 25, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '성별',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.convertedGender)],
            width: { size: 15, type: WidthType.PERCENTAGE },
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '경력',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 15, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.workPeriod)],
            width: { size: 20, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '등급',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 15, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.convertedGrade)],
            width: { size: 25, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '근무구분',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.convertedWorkType)],
            width: { size: 15, type: WidthType.PERCENTAGE },
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '휴대폰',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 15, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.formattedPhone)],
            verticalAlign: VerticalAlign.CENTER,
            width: { size: 20, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '이메일',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 15, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.email)],
            verticalAlign: VerticalAlign.CENTER,
            width: { size: 25, type: WidthType.PERCENTAGE },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '직위',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.position)],
            width: { size: 15, type: WidthType.PERCENTAGE },
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '주소',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.address)],
            // width: { size: 15, type: WidthType.PERCENTAGE },
            columnSpan: 5,
          }),
        ],
      }),
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '자격증',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.license)],
            // width: { size: 15, type: WidthType.PERCENTAGE },
            columnSpan: 2,
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '취득년월',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            width: { size: 10, type: WidthType.PERCENTAGE },
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [new Paragraph(personalInfo.formattedAcquisitionDate)],
            // width: { size: 15, type: WidthType.PERCENTAGE },
            columnSpan: 2,
            verticalAlign: VerticalAlign.CENTER,
          }),
        ],
      }),
    ],
  });
};

const createEducationTable = (educationData) => {
  return new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '학교명',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '전공',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '졸업여부',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '졸업일',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
        ],
      }),
      ...educationData.map(
        (data) =>
          new TableRow({
            children: [
              new TableCell({ children: [new Paragraph(data.schoolName)] }),
              new TableCell({ children: [new Paragraph(data.major)] }),
              new TableCell({ children: [new Paragraph(data.convertedStatus)] }),
              new TableCell({ children: [new Paragraph(data.formattedGraduationDate)] }),
            ],
          }),
      ),
    ],
  });
};

const createExperienceTable = (experienceData) => {
  return new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '회사명',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '근무기간',
                    bold: true,
                  }),
                  new TextRun({
                    break: 1, // 줄바꿈 추가
                  }),
                  new TextRun({
                    text: '(YYYY.MM ~ YYYY.MM)',
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '직위',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '담당업무',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
        ],
      }),
      ...experienceData.map(
        (data) =>
          new TableRow({
            children: [
              new TableCell({ children: [new Paragraph(data.companyName)] }),
              new TableCell({
                children: [new Paragraph(data.formattedWorkPeriod)],
              }),
              new TableCell({ children: [new Paragraph(data.position)] }),
              new TableCell({ children: [new Paragraph(data.duty)] }),
            ],
          }),
      ),
    ],
  });
};

const createProjectTable = (projectData) => {
  return new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '사업명',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '참여기간',
                    bold: true,
                  }),
                  new TextRun({
                    break: 1, // 줄바꿈 추가
                  }),
                  new TextRun({
                    text: '(YYYY.MM ~ YYYY.MM)',
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '고객사',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '근무회사',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '역할',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '사용기술',
                    bold: true,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
            shading: { type: ShadingType.CLEAR, color: 'auto', fill: 'D9D9D9' },
          }),
        ],
      }),
      ...projectData.map(
        (data) =>
          new TableRow({
            children: [
              new TableCell({ children: [new Paragraph(data.projectName)] }),
              new TableCell({ children: [new Paragraph(data.formattedWorkPeriod)] }),
              new TableCell({ children: [new Paragraph(data.clientCompany)] }),
              new TableCell({ children: [new Paragraph(data.employerCompany)] }),
              new TableCell({ children: [new Paragraph(data.duty)] }),
              new TableCell({ children: [new Paragraph(data.skill)] }),
            ],
          }),
      ),
    ],
  });
};

export const saveAsDocx = (data) => {
  const docTitle = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    layout: TableLayoutType.FIXED,
    rows: [
      new TableRow({
        children: [
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: '개 인 이 력 카 드',
                    size: 28,
                  }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            verticalAlign: VerticalAlign.CENTER,
          }),
        ],
      }),
    ],
  });

  const doc = new Document({
    sections: [
      {
        properties: {
          page: {
            size: {
              orientation: PageOrientation.PORTRAIT, // 세로
            },
            margin: {
              top: 1440,
              right: 1440,
              bottom: 1440,
              left: 1440,
            },
          },
        },
        children: [
          // 첫 번째 페이지 내용
          docTitle,
          new Paragraph(''), // 줄바꿈 추가
          createPersonalInfoTable(data.profileData),
          new Paragraph(''), // 줄바꿈 추가
          createTitle('학력'),
          createEducationTable(data.educationList),
          new Paragraph(''),
          createTitle('근무경력'),
          createExperienceTable(data.workExperienceList),
          new Paragraph({
            children: [new TextRun({ break: 1 })], // 페이지 넘김
          }),
        ],
      },
      {
        properties: {
          page: {
            size: {
              orientation: PageOrientation.LANDSCAPE, // 두 번째 페이지 가로 모드
            },
            margin: {
              top: 1440,
              right: 1440,
              bottom: 1440,
              left: 1440,
            },
          },
        },
        children: [
          // 두 번째 페이지 내용
          createTitle('기술경력'),
          createProjectTable(data.projectHistoryList),
        ],
      },
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `${data.profileData.name}_프로필.docx`);
  });
};
